import axios from 'axios';

export const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL,
});

/**
 * The login's JWT as request headers, for the REST downloads (invoice and
 * payout report PDFs) that now answer only the account they belong to.
 */
export const authHeaders = (
  token?: string | null,
): Record<string, string> => (
  token ? { Authorization: `Bearer ${token}` } : {}
);
